// テンプレートの登録簿(registry)。App はここから一覧と定義を読み、フォームとプレビューを組み立てる。
//
// テンプレートを追加する手順:
//   1. src/templates/ に新ファイル(例 minimal.ts)を作り、standard.ts を雛形に
//      TemplateDef({ id, label, fields, css, body })を default export ではなく named export する。
//   2. src/design.ts の TemplateKind にその id を足す。
//   3. 下の TEMPLATES にその1行を加える。以上(App.tsx などは無改修)。

import { type TemplateKind } from "../design";
import { type TemplateDef, mergeDefaults, type Values } from "./shared";
import { standardTemplate } from "./standard";
import { corporateTemplate } from "./corporate";

export const TEMPLATES: Record<TemplateKind, TemplateDef> = {
  standard: standardTemplate,
  corporate: corporateTemplate,
};

// フォームのテンプレート選択に使う一覧(登録順)。
export const TEMPLATE_LIST: { value: TemplateKind; label: string }[] = (
  Object.values(TEMPLATES) as TemplateDef[]
).map((t) => ({ value: t.id, label: t.label }));

// 初期テンプレートと、その既定値で埋めた初期 values。
export const INITIAL_TEMPLATE: TemplateKind = "standard";

export function makeDefaultConfig(): { template: TemplateKind; values: Values } {
  return {
    template: INITIAL_TEMPLATE,
    values: mergeDefaults({}, TEMPLATES[INITIAL_TEMPLATE]),
  };
}
